import { Component, onCleanup } from "solid-js";

type Props = {
    top?: number;
    buffer?: number;
    cutoff?: number;
    children: any;
}
export const Sticky : Component<Props> = (props) => {
    let sidebar: HTMLDivElement;
    const cutoff = props.cutoff || 400;
    const top = props.top || 50;
    const stick = () => {
        const width = sidebar.clientWidth || 200;
        const pos = document.body.scrollTop || document.documentElement.scrollTop;
        const newTop = (pos > cutoff) ? top : sidebar.parentElement?.offsetTop - pos;
        sidebar.style.position = "fixed";
        sidebar.style.top = newTop + "px";
        sidebar.style.width = width + "px";
    };
    const initialise = (el: HTMLDivElement) => {
        sidebar = el;
        const pageContainer = document.getElementsByClassName("page-container")[0] as HTMLDivElement;
        if (pageContainer) {
            pageContainer.style.overflowX = "hidden";
        }
        setupEventHandlers();
        stick();
    };
    const setupEventHandlers = () => {
        window.addEventListener("scroll", () => stick());
        window.addEventListener("resize", () => stick());
    };
    onCleanup(() => {
        window.removeEventListener("scroll", stick);
        window.removeEventListener("resize", stick);
    });
    return (<div ref={initialise}>{props.children}</div>)
}
